// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-tree-invisible {
  display: none;
}

.item-icon {
  background-color: inherit;
  border: none;
}

.mat-nested-tree-node div {
  padding-left: 0.5rem;
}

.parent-node {
  min-height: min-content;
  max-height: 1.8rem;
}

.mat-tree-node {
  position: relative;
  padding-left: 3rem;
  min-height: min-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/app/components/source-selection/source-selection.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,4BAAA;EAAA,uBAAA;AACF","sourcesContent":[".source-tree-invisible {\n  display: none;\n}\n\n.item-icon {\n  background-color: inherit;\n  border: none;\n}\n\n.mat-nested-tree-node div {\n  padding-left: 0.5rem;\n}\n\n.parent-node {\n  min-height: min-content;\n  max-height: 1.8rem;\n}\n\n.mat-tree-node {\n  position: relative;\n  padding-left: 3rem;\n  min-height: min-content;\n  max-height: fit-content;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
